import ProjectsList from '~/projects_list';

document.addEventListener('DOMContentLoaded', () => new ProjectsList());



// WEBPACK FOOTER //
// ./pages/explore/projects/index.js